import React, { useCallback, useEffect, useState } from 'react';
import { apiFetch } from '../services/apiClient';

// "❄ Needs winterizing" on the phone home (Ryan, Nov 2 2026): the machines ticked "needs to be
// winterized" that concern this person — every one for the shop crew, the Executives and the
// office; for a field supervisor the ones with them or on a job they are scheduled on. Each row
// says where it is and tomorrow's low. "Winterized — done" clears the tick on the machine, so it
// comes off everyone's list and out of everyone's bell at once. Renders nothing when the list is
// empty, so the home screen stays clean.
const dayLabel = d => (d ? new Date(d + 'T12:00:00').toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }) : '');

export default function WinterizeList() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState('');
  const [err, setErr] = useState('');
  const load = useCallback(() => apiFetch('/equipment/winterize-list').then(d => setData(d && Array.isArray(d.items) ? d : { items: [] })).catch(() => setData(d => d || { items: [] })), []);
  useEffect(() => { load(); const t = setInterval(load, 2 * 60 * 1000); return () => clearInterval(t); }, [load]);
  if (!data || !data.items.length) return null;
  async function done(it) {
    if (!window.confirm(`Mark ${it.asset_number ? it.asset_number + ' ' : ''}${it.name} as winterized? It comes off everyone's list.`)) return;
    setBusy(it.id); setErr('');
    try { await apiFetch(`/equipment/${it.id}/winterized`, { method: 'POST' }); await load(); }
    catch (e) { setErr(e?.error || e?.message || 'That did not save.'); }
    setBusy('');
  }
  const cold = data.items.filter(i => i.cold).length;
  return (
    <div style={{ background: '#fff', border: '1.5px solid #bfdbfe', borderLeft: '5px solid #2563eb', borderRadius: 14, padding: '12px 14px', marginTop: 12 }}>
      <div style={{ fontSize: 12, fontWeight: 800, color: '#1d4ed8', textTransform: 'uppercase', letterSpacing: 0.5 }}>
        ❄ Needs winterizing · {data.items.length}{cold ? <span style={{ color: '#b91c1c' }}> · {cold} with a freeze coming</span> : null}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 8 }}>
        {data.items.map(it => (
          <div key={it.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 10px', borderRadius: 10, background: it.cold ? '#fef2f2' : '#f8fafc', border: `1px solid ${it.cold ? '#fecaca' : '#e5e7eb'}` }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 14.5, fontWeight: 800, color: '#111827' }}>{it.asset_number ? `${it.asset_number} · ` : ''}{it.name}</div>
              <div style={{ fontSize: 12.5, color: '#4b5563', marginTop: 2 }}>
                {it.where}{it.assigned_to ? ` · with ${it.assigned_to}` : ''}
              </div>
              <div style={{ fontSize: 12.5, marginTop: 2, fontWeight: it.cold ? 800 : 500, color: it.cold ? '#b91c1c' : '#6b7280' }}>
                {it.low != null ? `Low ${it.low}°F ${dayLabel(it.tomorrow)}${it.cold ? ' — winterize today' : ''}` : 'No forecast yet'}
              </div>
            </div>
            {data.can_mark && (
              <button disabled={busy === it.id} onClick={() => done(it)}
                style={{ flex: 'none', padding: '9px 12px', borderRadius: 10, border: '1.5px solid #1d4ed8', background: '#1d4ed8', color: '#fff', fontSize: 13, fontWeight: 800, cursor: 'pointer', opacity: busy === it.id ? 0.6 : 1 }}>
                {busy === it.id ? 'Saving…' : '✓ Done'}
              </button>
            )}
          </div>
        ))}
      </div>
      {err && <div style={{ marginTop: 8, fontSize: 13, fontWeight: 700, color: '#b91c1c' }}>{err}</div>}
    </div>
  );
}
